import {
  processVariable,
  buildWhatsAppProcessedParams,
  isWhatsAppComplete,
} from '@chatwoot/utils';

// Constants and pure template helpers are shared with the mobile app via
// @chatwoot/utils so the logic lives in one place.
export {
  MEDIA_FORMATS,
  COMPONENT_TYPES,
  findComponentByType,
  processVariable,
  renderTemplatePreview,
} from '@chatwoot/utils';

export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CATEGORY = 'UTILITY';

export const allKeysRequired = value => {
  const keys = Object.keys(value);
  return keys.every(key => value[key]);
};

export const replaceTemplateVariables = (templateText, processedParams) => {
  return templateText.replace(/{{([^}]+)}}/g, (match, variable) => {
    const variableKey = processVariable(variable);
    return processedParams.body?.[variableKey] || `{{${variable}}}`;
  });
};

// The media-header flag is derived from the template inside the shared helper;
// the second argument is kept for backwards-compatible call sites.
export const buildTemplateParameters = template => {
  const params = buildWhatsAppProcessedParams(template);
  const buttons = template.components?.find(c => c.type === 'BUTTONS')?.buttons;
  buttons?.forEach((button, index) => {
    if (button.type === 'FLOW') {
      params.buttons ??= [];
      params.buttons[index] = { type: 'flow', action: {} };
    }
  });
  return params;
};

export const parseFlowData = (value, { allowEmpty = false } = {}) => {
  if (!value) return undefined;
  const data = JSON.parse(value);
  if (
    !data ||
    Array.isArray(data) ||
    typeof data !== 'object' ||
    (!allowEmpty && !Object.keys(data).length)
  ) {
    throw new Error('Flow data must be a non-empty JSON object');
  }
  return data;
};

export const isTemplateComplete = (template, params) => {
  const buttons = params.buttons?.filter(button => button?.type !== 'flow');
  return (
    isWhatsAppComplete(template, { ...params, buttons }) &&
    (buttons || []).every(button => !button || button.parameter?.trim())
  );
};

export const FLOW_BODY_LIMIT = 1024;
export const FLOW_CTA_LIMIT = 30;
const FLOW_EMOJI_PATTERN =
  /\p{Extended_Pictographic}|\p{Emoji_Presentation}|\u200d|\ufe0f|\u20e3/u;
export const isValidFlowCta = value =>
  Boolean(value.trim()) &&
  value.length <= FLOW_CTA_LIMIT &&
  !FLOW_EMOJI_PATTERN.test(value);
